module.exports = __webpack_public_path__ + "img/news_02.d4f3fb92.jpg";